"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getFieldValue;

function getFieldValue(obj, field) {
  if (typeof field === 'string') {
    return field.split('.').reduce(function (acc, item) {
      var value = acc[item];

      if (value !== undefined) {
        return value;
      }

      return '';
    }, obj);
  }

  return '';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/Table/helpers/rows/getFieldValue.js
// module id = Obiw
// module chunks = 0